export const lightTheme = {
  colors: {
    background: "#FFFFFF",
    primary: "#624d40", // marrom principal
    secondary: "#E6AEB5", // rosa suave
    accent: "#F2D7DA", // rosa claro
    text: {
      primary: "#4E342E",
      secondary: "#7A6A5C",
      contrast: "#FFFFFF",
      onSecondary: "#FFFFFF",
    },
    border: "#E0E0E0",
    card: "#FAFAFA",
  },
  radii: {
    small: "6px",
    medium: "12px",
    large: "20px",
    pill: "9999px",
  },
  shadows: {
    small: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    medium: "0px 4px 8px rgba(0, 0, 0, 0.15)",
    large: "0px 8px 16px rgba(0, 0, 0, 0.2)",
  },
  patterns: {
    floral: "url('/assets/patterns/floral-light.png')", // opcional para fundo
  },
};
export const darkTheme = {
  colors: {
    background: "#1E1A17", // Fundo mais escuro para melhor contraste
    primary: "#F2B8C0", // Rosa mais claro e vibrante
    secondary: "#8B6F5C", // Marrom mais claro
    accent: "#E6A8B5", // Rosa accent mais suave
    text: {
      primary: "#FFFFFF", // Texto principal branco puro
      secondary: "#D4C5BD", // Texto secundário mais claro
      contrast: "#1E1A17", // Contraste ajustado ao novo fundo
      onSecondary: "#FFFFFF",
    },
    border: "#4A3B32", // Bordas mais claras
    card: "#2F2924", // Cards mais claros que o fundo
  },
  radii: {
    small: "6px",
    medium: "12px",
    large: "20px",
    pill: "9999px",
  },
  shadows: {
    small: "0px 2px 4px rgba(0, 0, 0, 0.6)",
    medium: "0px 4px 8px rgba(0, 0, 0, 0.7)",
    large: "0px 8px 16px rgba(0, 0, 0, 0.8)",
  },
  patterns: {
    floral: "url('/assets/patterns/floral-dark.png')",
  },
};
export const getComponentTokens = (isDark: boolean) => ({
  guestDetails: {
    skeleton: {
      pt: "70px",
      px: 2,
      pb: 2,
      maxWidth: 600,
      mx: "auto",
    },
    sectionTitle: {
      color: isDark ? "#E0D6CF" : "#333333",
      marginBottom: "8px",
    },
    listItemIcon: {
      marginRight: "8px",
      color: isDark ? "#D4C5BD" : "#555555",
    },
    button: {
      background: isDark ? "#8B6F5C" : "#6D5C5C",
      hover: isDark ? "#7A5F4F" : "#5A4C4C",
      textColor: "#FFFFFF",
      borderRadius: "8px",
      padding: "12px",
    },
    contactCard: {
      background: isDark ? "#3D2E28" : "#E6A9A9",
      textColor: isDark ? "#E0D6CF" : "#333333",
    },
  },
} as const);
export const componentTokens = getComponentTokens(false);
export type ComponentTokens = ReturnType<typeof getComponentTokens>;
export type ThemeType = typeof lightTheme;